export function cycleStatus(current) {
  const order = [
    "new",
    "in_progress",
    "done",
  ];

  const index = order.indexOf(current);

  return order[
    (index + 1) % order.length
  ];
}


export function cyclePriority(current) {
  const order = [
    "low",
    "medium",
    "high",
  ];

  const index = order.indexOf(current);

  return order[
    (index + 1) % order.length
  ];
}


export function statusColor(status) {

  switch (status) {

    case "new":
      return "bg-slate-600 text-white";

    case "in_progress":
      return "bg-yellow-600 text-black";

    case "done":
      return "bg-green-600 text-white";

    default:
      return "bg-slate-600 text-white";
  }
}


export function priorityColor(priority) {

  switch(priority) {

    case "high":
      return `
        bg-red-500/20
        text-red-400
        border-red-500/30
      `;

    case "medium":
      return `
        bg-yellow-500/20
        text-yellow-400
        border-yellow-500/30
      `;

    default:
      return `
        bg-slate-500/20
        text-slate-300
        border-slate-500/30
      `;
  }

}